import {
  PSMS_CALLS_CHATS_DETAILS_REQUEST,
  PSMS_CALLS_CHATS_DETAILS_SUCCESS,
  PSMS_CALLS_CHATS_DETAILS_FAILURE,
  PSMS_CALLS_CHATS_DETAILS_LOADING,
  PSMS_CALLS_CHATS_TREND_REQUEST,
  PSMS_CALLS_CHATS_TREND_SUCCESS,
  PSMS_CALLS_CHATS_TREND_FAILURE,
  PSMS_CALLS_CHATS_TREND_LOADING,
} from '../../actions/actionTypes';

export interface CallsChatsState {
  data: any;
  loading: boolean;
  error: string | null;
  trendData: any;
  trendLoading: boolean;
  trendError: string | null;
}

const initialState: CallsChatsState = {
  data: null,
  loading: true,
  error: null,
  trendData: null,
  trendLoading: true,
  trendError: null,
};

export default function callsChatsReducer(
  state: CallsChatsState = initialState,
  action: any
): CallsChatsState {
  switch (action.type) {
    case PSMS_CALLS_CHATS_DETAILS_REQUEST:
      return { ...state, loading: true, data: null, error: null };
    case PSMS_CALLS_CHATS_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case PSMS_CALLS_CHATS_DETAILS_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };
    case PSMS_CALLS_CHATS_DETAILS_LOADING:
      return { ...state, loading: action.payload };
    case PSMS_CALLS_CHATS_TREND_REQUEST:
      return { ...state, trendLoading: true, trendData: null, trendError: null };
    case PSMS_CALLS_CHATS_TREND_SUCCESS:
      return { ...state, trendLoading: false, trendData: action.payload, trendError: null };
    case PSMS_CALLS_CHATS_TREND_FAILURE:
      return { ...state, trendLoading: false, trendData: null, trendError: action.payload };
    case PSMS_CALLS_CHATS_TREND_LOADING:
      return { ...state, trendLoading: action.payload };
    default:
      return state;
  }
}
